( function () {
	'use strict';

	function evidenceTimer ( ) {
		function link ( scope, element ) {
			// for firefox remove focus in timer readonly input
			element.find( '.timer-input' ).focus( function () {
				angular.element( this ).blur();
			} );
		}

		return {
			'link'         : link,
			'templateUrl'  : '/templates/components/evidences/timer/evidence-timer.html',
			'restrict'     : 'E',
			'controller'   : 'EvidenceTimer',
			'controllerAs' : 'vm',
			'scope'        : {
				'model'         : '=',
				'index'         : '=',
				'time'          : '=',
				'timerEvidence' : '='
			}
		};
	}

	angular
		.module( 'app.templates' )
		.directive( 'evidenceTimer', evidenceTimer );
} )( );
